import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import { LoginComponent } from './login/login.component';
import { PublicationComponent } from './publication/publication.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { CreditComponent } from './credit/credit.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { HttpClientModule } from '@angular/common/http';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { ChooseoptionsComponent } from './chooseoptions/chooseoptions.component';
import { AreaselectionComponent } from './areaselection/areaselection.component';
import { MatRadioModule } from '@angular/material/radio';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { LocationComponent } from './location/location.component';
import { TermsandconditionComponent } from './termsandcondition/termsandcondition.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OutputsComponent } from './outputs/outputs.component';
import { OutputresourceComponent } from './outputresource/outputresource.component';
import { OutputplantdesignComponent } from './outputplantdesign/outputplantdesign.component';
import { OutputtechnicalComponent } from './outputtechnical/outputtechnical.component';
import { SunhoursComponent } from './outputresource/sunhours/sunhours.component'
import { ChartModule } from 'angular-highcharts';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OutputfinancialComponent } from './outputfinancial/outputfinancial.component';
import { PlantlistComponent } from './plantlist/plantlist.component';
import { Ng5SliderModule } from 'ng5-slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MatTabsModule } from '@angular/material/tabs';
import { StatsComponent } from './stats/stats.component';
import { DemoComponent } from './demo/demo.component';
import { AgmCoreModule } from '@agm/core';
import { GoogleAnalyticsService } from './google-analytics.service';
import { AppinfoComponent } from './appinfo/appinfo.component'; // import our analytics service
import { MatIconModule } from '@angular/material/icon';
import { AppinputsComponent } from './appinputs/appinputs.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PublicationComponent,
    FeedbackComponent,
    CreditComponent,
    OtpVerifyComponent,
    ChooseoptionsComponent,
    AreaselectionComponent,
    LocationComponent,
    TermsandconditionComponent,
    ForgotpasswordComponent,
    OutputsComponent,
    OutputresourceComponent,
    OutputplantdesignComponent,
    OutputtechnicalComponent,
    SunhoursComponent,
    OutputfinancialComponent,
    PlantlistComponent,
    StatsComponent,
    DemoComponent,
    AppinfoComponent,
    AppinputsComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    LeafletModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCYIxRRaMi3lC7ztjDiGIyLSJcxXXPqd2c',
      libraries: ['geometry,places']
    }),
    GooglePlaceModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    ChartModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    BrowserAnimationsModule, MatButtonModule, MatRadioModule, MatCheckboxModule, MatProgressSpinnerModule,
    Ng5SliderModule, MatTooltipModule, MatTabsModule,
    CarouselModule,
    MatIconModule
  ],
  providers: [AuthService, AuthGuard, GoogleAnalyticsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
